import {makeLxTranslations} from "@lxo-blocks/react";

const TOTP_FORM_TRANSLATION =  makeLxTranslations({
    namespace: "totpFormTranslations",
    translations: {
        LOGIN_TOTP_FAILED: "Zwei-Faktor-Authentifizierung fehlgeschlagen.",
        LOGIN_TOTP_FAILED_TRY_AGAIN: "Falscher Code. Bitte versuchen Sie es erneut.",
        TOTP_CODE_REQUIRED: "Bitte geben Sie Ihren Code ein",
        TOTP_TEXT: "Geben Sie den Sicherheitscode aus Ihrer Authentificator-App ein.",
        TOTP_INPUT_PLACEHOLDER: "000-000",
        TOTP_INPUT_LABEL: "Code eingeben",
    }
});

export {TOTP_FORM_TRANSLATION};
